import { injectable } from "@launchtray/tsyringe-async";
import { Ticker } from "pixi.js";

@injectable()
export class TickerModel {
    private count: number = 0;

    constructor() {
    }

    public onPauseRequest(): void {
        this.count++;
        if(Ticker.shared.started) {
            Ticker.shared.stop();
        }
    }

    public onResumeRequest(): void {
        if (this.count === 0) {
            return;
        }
        this.count--;
        if(this.count === 0) {
            if (!Ticker.shared.started) {
                Ticker.shared.start();
            }
        }
    }

}
